<div class="wrapper mat-elevation-z10">
    <div class="title">
        <span>
            <h1>{{ isOfficeReceipt ? 'Office' : 'Client' }} Expected Funds</h1>
        </span>
    </div>

    <div class="form-container">
        <form [formGroup]="expectFundForm" class="form" #formDirective="ngForm" (ngSubmit)="submit(formDirective)">

            <mat-form-field class="halfLength">
                <mat-label>Payment method</mat-label>
                <mat-select formControlName="paymentMethod">
                    <mat-option *ngFor="let method of paymentMethodDropdown" [value]="method">{{ method }}</mat-option>
                </mat-select>
                @if (expectFundForm.get('paymentMethod')?.touched && expectFundForm.get('paymentMethod')?.invalid) {
                <mat-error>Please select a valid payment method.</mat-error>
                }
            </mat-form-field>

            <div class="fullLength">
                <mat-form-field class="matterAuto">
                    <mat-label>Matter</mat-label>
                    @if (expectFundForm.get('matter')?.value) {
                    <button type="button" (click)="clearSearchFilter()" mat-icon-button matSuffix>
                        <mat-icon>clear</mat-icon>
                    </button>
                    }
                    <input matInput formControlName="matter" [matAutocomplete]="auto" />
                    @if (expectFundForm.get('matter')?.touched && expectFundForm.get('matter')?.invalid) {
                    <mat-error>Please select a matter.</mat-error>
                    }
                </mat-form-field>

                <mat-autocomplete #auto="matAutocomplete">
                    @if (isLoading) {
                    <mat-option>Loading...</mat-option>
                    } @else if (noData) {
                    <mat-option>No matching matters found.</mat-option>
                    } @else {
                    <mat-option *ngFor="let item of matterDropdownData"
                                [value]="displayMatter(item)"
                                (onSelectionChange)="lookupSelectionChanged($event)">
                        {{ item.number }} - {{ item.description }}
                    </mat-option>
                    }
                </mat-autocomplete>
            </div>

            @if (showLinkToOpenMatter()) {
            <div class="sticky-actionstep-bar">
                <div class="link-wrapper">
                    <a [href]="actionstepMatterUrl" target="_blank" rel="noopener noreferrer">
                        Open Matter in Actionstep ({{ matterNo }})
                    </a>
                    <button type="button" mat-icon-button class="small-copy-btn"
                            [cdkCopyToClipboard]="actionstepMatterUrl"
                            (cdkCopyToClipboardCopied)="onUrlCopied()"
                            matTooltip="Copy link to clipboard" matTooltipPosition="below">
                        <mat-icon>content_copy</mat-icon>
                    </button>
                </div>
                <div class="warning-box">You must be logged into Actionstep under the same jurisdiction.</div>
            </div>
            }

            <mat-form-field class="fullLength">
                <mat-label>Client Name</mat-label>
                <input matInput formControlName="clientName" readonly />
                @if (isLoading) {
                <mat-progress-spinner class="spinner-padding" matSuffix
                                      mode="indeterminate" diameter="20" strokeWidth="3" color="accent">
                </mat-progress-spinner>
                }
            </mat-form-field>

            <mat-form-field class="fullLength">
                <mat-label>Reason for expected funds</mat-label>
                <input matInput formControlName="paymentReason" />
                @if (expectFundForm.get('paymentReason')?.touched && expectFundForm.get('paymentReason')?.invalid) {
                <mat-error>Please enter a reason for expected funds.</mat-error>
                }
            </mat-form-field>

            <div class="date-time-row">
                <mat-form-field color="accent" class="date-field">
                    <mat-label>Requested Date</mat-label>
                    <input matInput [matDatepicker]="requestedDatePicker" formControlName="dateRequested" placeholder="dd/MM/yyyy" [max]="currentDate"/>
                    <mat-datepicker-toggle matSuffix [for]="requestedDatePicker" />
                    <mat-datepicker #requestedDatePicker />
                    @if (expectFundForm.get('dateRequested')?.touched && expectFundForm.get('dateRequested')?.invalid) {
                    <mat-error>Please select a date.</mat-error>
                    }
                </mat-form-field>

                <mat-form-field color="accent" class="time-field">
                    <mat-label>Requested Time</mat-label>
                    <input matInput type="time" formControlName="requestedTime" placeholder="HH:mm" />
                    @if (expectFundForm.get('requestedTime')?.touched && expectFundForm.get('requestedTime')?.invalid) {
                    <mat-error>Please enter a time.</mat-error>
                    }
                </mat-form-field>
            </div>

            <mat-form-field>
                <mat-label>Currency</mat-label>
                <mat-select formControlName="currencyId">
                    <mat-option *ngFor="let c of currencyDropdown" [value]="c.id">
                        {{ c.currencyCode }} - {{ c.symbol }}
                    </mat-option>
                </mat-select>
                <mat-error>Please select a currency code.</mat-error>
            </mat-form-field>

            <mat-form-field>
                <mat-label>Expected amount to be received</mat-label>
                <input matInput maxlength="12" formControlName="expectedAmount"
                       (keydown)="validateInput($event)" (blur)="formatNumber()" />
                @if (expectFundForm.get('expectedAmount')?.touched && expectFundForm.get('expectedAmount')?.invalid) {
                <mat-error>Please enter a valid amount.</mat-error>
                }
            </mat-form-field>

            <mat-form-field class="w-100">
                <mat-label>{{ isOfficeReceipt ? 'Office bank' : 'Client bank' }}</mat-label>
                <mat-select formControlName="clientBankAccount">
                    <mat-option *ngFor="let account of filteredBankAccounts" [value]="account">
                        {{ account.accountId }} - {{ account.description }}
                    </mat-option>
                </mat-select>
                @if (expectFundForm.get('clientBankAccount')?.touched &&
                expectFundForm.get('clientBankAccount')?.hasError('required')) {
                <mat-error>Please select a bank account.</mat-error>
                }
            </mat-form-field>

            @if (showLinkToOpenMatter()) {
            <div class="actionstep-matter-overview">
                <div class="link-wrapper">
                    <a [href]="actionstepMatterOverviewUrl" target="_blank" rel="noopener noreferrer">
                        Open Actionstep Matter ({{ matterNo }}) Overview to view linked accounts
                    </a>
                    <button type="button" mat-icon-button class="small-copy-btn"
                            [cdkCopyToClipboard]="actionstepMatterOverviewUrl"
                            (cdkCopyToClipboardCopied)="onUrlCopied()"
                            matTooltip="Copy link to clipboard" matTooltipPosition="below">
                        <mat-icon>content_copy</mat-icon>
                    </button>
                </div>
                <div class="warning-box">You must be logged into Actionstep under the same jurisdiction.</div>
            </div>
            }

            <mat-form-field class="fullLength">
                <mat-label>Notes to accounts</mat-label>
                <textarea matInput formControlName="notesToAccounts"></textarea>
            </mat-form-field>

            <mat-form-field class="fullLength">
                <mat-label>Are monies coming from client?</mat-label>
                <mat-select formControlName="moniesReturnedClient">
                    <mat-option [value]="true">Yes</mat-option>
                    <mat-option [value]="false">No</mat-option>
                </mat-select>
                @if (expectFundForm.get('moniesReturnedClient')?.touched &&
                expectFundForm.get('moniesReturnedClient')?.invalid) {
                <mat-error>Please select Yes or No.</mat-error>
                }
            </mat-form-field>

            @if (showPayerSelect) {
            <mat-form-field class="fullLength">
                <mat-label>Received from</mat-label>
                <mat-select multiple required panelClass="sw-multi-select-panel" [formControl]="payerClients"
                            [errorStateMatcher]="payerErrorMatcher"
                            (selectionChange)="onPayerClientsChange()"
                            (openedChange)="onPayerSelectOpened($event)">
                    @for (name of clientOptions; track name) {
                    <mat-option [value]="name">{{ name }}</mat-option>
                    }
                </mat-select>
                <mat-error>Please select at least one payee.</mat-error>
            </mat-form-field>
            } @else {
            <mat-form-field class="fullLength">
                <mat-label>Received from</mat-label>
                <input matInput formControlName="payerName" [readonly]="isPayerReadOnly" />
                @if (expectFundForm.get('payerName')?.touched && expectFundForm.get('payerName')?.invalid) {
                <mat-error>Please enter who the funds are received from.</mat-error>
                }
            </mat-form-field>
            }

            @if (isUserPartner === false) {
            <div class="fullLength">
                <mat-form-field>
                    <mat-label>Partner authorising</mat-label>
                    <mat-select formControlName="partnerAuthorisingId">
                        <mat-option *ngFor="let item of partnerList" [value]="item.id">
                            {{ item.name }}
                        </mat-option>
                    </mat-select>
                    @if (expectFundForm.get('partnerAuthorisingId')?.touched &&
                    expectFundForm.get('partnerAuthorisingId')?.hasError('required')) {
                    <mat-error>Partner authorising is required.</mat-error>
                    }
                </mat-form-field>
            </div>
            }

            <xp-draft-documents class="fullLength"
                                [documents]="draftEditor.documents()"
                                (remove)="draftEditor.removeDocument($event)" />

            <mat-form-field class="fullLength">
                <mat-label>Files to upload</mat-label>
                <input matInput [value]="displayFile.join(', ')" placeholder="Please select a file" readonly />
                <button type="button" (click)="fileInput.click()" mat-icon-button matSuffix>
                    <mat-icon>upload_file</mat-icon>
                </button>
                @if (displayFile.length > 0) {
                <button type="button" (click)="clearUpload()" mat-icon-button matSuffix>
                    <mat-icon>clear</mat-icon>
                </button>
                }
                <input type="file" #fileInput (change)="onFilesSelected($any($event.target))" multiple hidden />
            </mat-form-field>

            @if (isUserPartner) {
            <div class="fullLength">
                <mat-checkbox formControlName="isPartnerCertified">
                    I certify that<span class="important">*</span>
                </mat-checkbox>
                <ul>
                    <li>The information contained in this form has been verified by me and is accurate.</li>
                    <li>This receipt is in accordance with the Accounts Policy (including Direct Policy)* and Sanctions Policy.</li>
                    <li>I have undertaken source of funds checks and that they are satisfactory.</li>
                </ul>
                <p>If any doubt, please contact a senior member of the Compliance Team.</p>
            </div>
            }

            <div class="action-button">
                <xp-draft-actions [draftName]="draftEditor.draftName()"
                                  [busy]="draftEditor.saving()"
                                  [disabled]="!canSaveDraft || submitBtn"
                                  (saveDraft)="saveDraftAndReset(formDirective)" />
                <button type="submit" mat-raised-button class="submit-btn mat-accent"
                        [disabled]="submitBtn || draftEditor.saving() || expectFundForm.invalid">
                    {{ isUserPartner ? 'Submit For Account Approval' : 'Submit For Partner Approval' }}
                </button>
            </div>

        </form>
    </div>
</div>
